import { ROUTES } from '../../../utils/constants';

const state = {
  links: [{
    name: 'Sales',
    route: { name: ROUTES.ADMIN_REPORTS_SALES.NAME }
  }, {
    name: 'Payouts',
    route: { name: ROUTES.ADMIN_REPORTS_PAYOUTS.NAME }
  }]
};

const getters = {};

const actions = {};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
